import { defaultApiState } from '@/store/types/general.types';
import { CoursePackageState } from './course-package.types';

export const coursePackageState: CoursePackageState = {
  apiState: {
    upsertCoursePackageApi: defaultApiState,
    deleteCoursePackageApi: defaultApiState
  },
  upsertedCoursePackage: undefined,
  coursePackageTabState: {
    activeCoursePackages: [],
    coursePackageFormHasError: false
  }
};
